import React, { PropTypes } from 'react'

const CheckCircle = props => (
  <svg width='63' height='63' xmlns='http://www.w3.org/2000/svg'>
    <g
      transform='translate(1 1)'
      stroke='#C78C2F'
      fill='none'
      fillRule='evenodd'>
      <circle cx='30.5' cy='30.5' r='30.5' />
      <path
        d='M18 31l8.5 9.5m0 0l19-19'
        strokeWidth='2'
        strokeLinecap='round'
      />
    </g>
  </svg>
)

CheckCircle.propTypes = {
  key: PropTypes.number
}

export default CheckCircle



// WEBPACK FOOTER //
// ./src/svg-icons/CheckCircle.js